import React from "react";
import logoB from "../../media/images/logo-b.svg";

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <div className="logo">
        <img src={logoB} alt="logo" />
      </div>
    </div>
  );
};

export default SplashScreen;
